module.exports = __webpack_public_path__ + "static/media/auchan3.6c37e258.jpg";